export function collectDeviceFingerprint(): string | null {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return null;
  }

  try {
    const { userAgent, platform, language, languages, hardwareConcurrency } = navigator;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone ?? 'unknown';
    const screenDescriptor =
      typeof window.screen !== 'undefined'
        ? `${window.screen.width}x${window.screen.height}x${window.screen.colorDepth}`
        : 'n/a';
    const languageList = Array.isArray(languages) ? languages.join(',') : language ?? '';
    return [
      userAgent ?? 'ua',
      platform ?? 'platform',
      languageList,
      timezone,
      screenDescriptor,
      hardwareConcurrency ?? 0
    ].join('|');
  } catch {
    return null;
  }
}
